module.exports = __webpack_public_path__ + "static/media/pizza-4-darker.5236f2b0.jpg";